var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-0 ma-0",attrs:{"fluid":""}},[_c('v-alert',{staticClass:"ma-5",attrs:{"border":"right","colored-border":"","type":"error","elevation":"2"}},[_vm._v(" Merci de contacter l’administrateur pour plus d’information. ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }